import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import theme from "./theme";
import { AuthProvider } from "./contexts/authContext";
import { CartProvider } from "./contexts/cartContext";
import AppShell from "./components/appShell";
import ProtectedRoute from "./components/protectedRoute";
import ShopPage from "./pages/shopPage";
import LoginPage from "./pages/loginPage";
import SignupPage from "./pages/signupPage";
import AccountPage from "./pages/accountPage";
import AdminPage from "./pages/adminPage";
import CategoryPage from "./pages/categoryPage";
import PurchasePage from "./pages/purchasePage";
import OrdersPage from "./pages/ordersPage";
import NotFoundPage from "./pages/notFoundPage";

const App = () => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <Routes>
            <Route element={<AppShell />}>
              <Route path="/" element={<ShopPage />} />
              <Route path="/category/:slug" element={<CategoryPage />} />
              <Route path="/purchase" element={<PurchasePage />} />
              <Route
                path="/orders"
                element={
                  <ProtectedRoute>
                    <OrdersPage />
                  </ProtectedRoute>
                }
              />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/signup" element={<SignupPage />} />
              <Route
                path="/account"
                element={
                  <ProtectedRoute>
                    <AccountPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute adminOnly>
                    <AdminPage />
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Routes>
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  </ThemeProvider>
);

export default App;
